import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: " What does a web development company do?",
    answer: `<p>A web development company helps you build a website or an application for business or personal use. The process of creating a website varies from one company to another, but many web development businesses follow similar procedures. As a bespoke web development company in UK, TekRevol deploys a custom approach to facilitate each business accordingly with a steadfast journey for web design and development.</p>`,
  },
  {
    question: "How do I choose a web development company?",
    answer: `<p>Here are five crucial factors to weigh when selecting a web development company in London:</p> 
        <ul>
        <li>Specify the type of website you require.</li>
        <li>Assess your compatibility with the company.</li>
        <li>Evaluate the level of support you'll need.</li>
        <li>Pay attention to details.</li>
        <li>Consider all associated costs.</li>
    </ul>`,
  },
  {
    question: " How do I hire a web design company?",
    answer: ` <p>Hiring a web designer for web development in London requires some essentials steps. Here are those:</p> 
        <ul>
        <li>Initiate with a Google search. Google aims to deliver optimal results for users.</li>
        <li>Examine reviews for each web design agency.</li>
        <li>Record comprehensive notes.</li>
        <li>Trim down your list of web design agencies.</li>
        <li>Place some phone calls.</li>
        <li>Finalize your selection of a web design agency after narrowing down your list.</li>
    </ul>`,
  },
  {
    question: " Are web developers in demand UK?",
    answer: `<p>The demand for skilled web developers in UK to craft mobile-friendly sites is expected to persist beyond 2023. At TekRevol, our team recognizes the importance of prioritizing mobile development in their efforts. Considering the current competitive landscape of the web development industry, we are continuously improving our process to ensure the maximum impact.</p> 
        <ul>
        <li><strong>Simple App Development :</strong> 2 - 4 months</li>
        <li><strong>Average App Development :</strong> 4 - 6 months</li>
        <li><strong>Complex App Development :</strong> 9+ months</li>
    </ul>`,
  },
  {
    question: " How much does web development cost UK?",
    answer: ` <p>Here’s the cost segmentation of web development in London according to different business scales:</p>  
        <ul>
        <li><strong>Small business website :</strong> £1600 to £7200 , Up to £960</li>
        <li><strong>Corporate website :</strong> £8000 to £28000 , Up to £12000</li>
        <li><strong>E-commerce website :</strong> £4000 to £44000 , Up to £24000</li>
        <li><strong>Web application :</strong> £4800 to £60000 , Up to £48000</li>
    </ul>`,
  },
  {
    question: "How long does it take to build a website?",
    answer: `<p>Typically, the timeframe for constructing a website ranges from one to six months, based on your objectives and available resources. We understand that a vague "it depends" might not be the most satisfying response, especially when you're eager to launch your website. However, this segment will delve into the specific factors influencing that timeframe.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
